import React, { useState } from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import HttpMethodBadge from '../../HttpMethodBadge';

const AuthApiList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleAccordion = (e: { stopPropagation: () => void; }) => {
        e.stopPropagation(); // Prevent event bubbling
        setIsOpen(prev => !prev);
    };

    // const driverApiList = [
    //     {
    //         apiName: 'Create Driver API',
    //         navigationId: 'createDriver' 
    //     },
    //     {
            
    //     }
    // ]


    return (
        <Box
            sx={{ display: 'flex', cursor: 'pointer', flexDirection: 'column', gap: 1 }}
            onClick={toggleAccordion}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FolderOutlinedIcon style={{ fontSize: 18 }} />
                    <Typography variant="body2" fontWeight={600} fontSize={14}>
                        Authentications
                    </Typography>
                </Box>
                <IconButton
                    size="small"
                    onClick={toggleAccordion}
                >
                    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>

            {isOpen && (
                <Box pl={4} width="100%">
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1, 
                            textDecoration: 'underline', 
                            cursor: 'pointer' 
                        }}
                        onClick={() => {
                            const introElement = document.getElementById("authentication");
                            if (introElement) {
                                introElement.scrollIntoView({ behavior: "smooth", block: "start" });
                            }
                        }}
                    >
                        <HttpMethodBadge method="POST" />
                        <Typography variant="body2" fontWeight={400} fontSize={14}>
                            Login
                        </Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default AuthApiList;
